import { GGCustomMessageDetails, GGCustomMessageType } from './GGCustomMessageTypes'
import OrderCompletedCard from './GGCustomMessages/OrderCompletedCard';
import OrderProposalActionTakenCard from './GGCustomMessages/OrderProposalActionTakenCard';
import OrderSubmittedBySellerCard from './GGCustomMessages/OrderSubmittedBySellerCard';
import PaymentCard from './GGCustomMessages/PaymentCard';
import ProgressReviewCard from './GGCustomMessages/ProgressReviewCard';
import RevisionRequestCard from './GGCustomMessages/RevisionRequestCard';

interface GGCustomMessageProps {
  customMessageDetails: GGCustomMessageDetails
  channelId: string
}

const GGCustomMessage = ({ customMessageDetails, channelId }: GGCustomMessageProps) => {
  const { type } = customMessageDetails;

  const renderCustomMessageView = () => {

    switch (type) {
      case GGCustomMessageType.orderPaymentCard:
        return <PaymentCard actionCardId={customMessageDetails.actionCardId} channelId={channelId} />
      
      case GGCustomMessageType.orderProposalActionTakenCard:
        return <OrderProposalActionTakenCard orderActionType={customMessageDetails.orderAction} orderMetaData={customMessageDetails.orderMetaData} />

      case GGCustomMessageType.revisionRequestCard:
        return <RevisionRequestCard revisionId={customMessageDetails.revisionId} />

      case GGCustomMessageType.progressReviewCard:
        return <ProgressReviewCard progressReviewId={customMessageDetails.progressReviewId} />

      case GGCustomMessageType.orderSubmittedBySellerCard:
        return <OrderSubmittedBySellerCard orderId={customMessageDetails.orderId} orderMetaData={customMessageDetails.orderMetaData}  />

      case GGCustomMessageType.orderCompletedCard:
        return <OrderCompletedCard orderId={customMessageDetails.orderId} orderCompletionTimeStamp={customMessageDetails.orderCompletionTimeStamp} orderMetaData={customMessageDetails.orderMetaData} />

      default:
        return <div>Something went wrong. Un-supported message found of type - {type}</div>;
    }
  };

  return <div>{renderCustomMessageView()}</div>;
};

export default GGCustomMessage;
